import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userChargeNotificationMessages = {
  [AutomationEventTypes.ChargeCreated]: {
    subject: 'Upcoming Charge Notification – *|GUEST:NAME|* at *|RENTAL:NAME|*',
    message: `
      Hi Team,

      Please review the following charge and ensure it is processed as scheduled. Let me know if there are any issues or updates needed.

      Charge Details:
      Guest Name: *|GUEST:NAME|*
      Charge Amount: *|CHARGE:AMOUNT|*
      Description: *|CHARGE:DESCRIPTION|*

      Thank you for your prompt attention to this matter.
      `,
  },
  [AutomationEventTypes.ChargeFailed]: {
    subject: 'Payment Failed – *|GUEST:NAME|* at *|RENTAL:NAME|*',
    message: `
      Hi Team,

      A payment attempt for *|GUEST:NAME|* at *|RENTAL:NAME|* has failed.

      Guest Details:
      Guest Name: *|GUEST:NAME|*
      Rental Name: *|RENTAL:NAME|*
      Please follow up with the guest to resolve the issue and ensure payment is completed. Let us know if further action is required.
    `,
  },
  [AutomationEventTypes.ChargeDeleted]: {
    subject: 'Charge Deleted – *|GUEST:NAME|* at *|RENTAL:NAME|*',
    message: `
      Hi Team,

      Please be informed that a charge of *|CHARGE:AMOUNT|* for *|GUEST:NAME|* at *|RENTAL:NAME|* has been deleted.

      Charge Details:
      Guest Name: *|GUEST:NAME|*
      Charge Amount: *|CHARGE:AMOUNT|*
      Description: *|CHARGE:DESCRIPTION|*
      If further actions are needed or there are any issues, please ensure they are addressed promptly.
    `,
  },
}

export const guestChargeNotificationMessages = {
  [AutomationEventTypes.ChargeCreated]: {
    subject: 'Notification of Upcoming Charge for Your Stay at *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We hope this message finds you well! We’re reaching out to notify you of an upcoming charge related to your stay at *|RENTAL:NAME|*.

      Charge Details:

      Amount: *|CHARGE:AMOUNT|*
      Description: *|CHARGE:DESCRIPTION|*
      This charge will be applied to the payment method you provided during booking. If you have any questions or concerns, please don’t hesitate to contact us at *|RENTAL:PHONE|*.

      Thank you, and we look forward to hosting you soon!
      `,
  },
  [AutomationEventTypes.ChargePaid]: {
    subject: 'Charge Confirmation for Your Stay at *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We’re pleased to inform you that your recent payment has been successfully processed.

      Payment Details:
      Amount Charged: *|CHARGE:AMOUNT|*
      Description: *|CHARGE:DESCRIPTION|*
      If you have any questions or need further assistance, please don’t hesitate to contact us at *|RENTAL:PHONE|*.

      Thank you for choosing *|RENTAL:NAME|*. We look forward to hosting you!
      `,
  },
  [AutomationEventTypes.ChargeFailed]: {
    subject: 'Payment Failed for Your Stay at *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We attempted to process a payment for your stay at *|RENTAL:NAME|*, but unfortunately, the payment was unsuccessful.

      To avoid any disruptions to your booking, please update your payment method or contact us at *|RENTAL:PHONE|* at your earliest convenience.

      If you need assistance, we’re here to help.
      `,
  },
  [AutomationEventTypes.ChargeDeleted]: {
    subject: 'Deleted Charge Notification – *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We want to inform you that a charge of *|CHARGE:AMOUNT|* associated with your booking at *|RENTAL:NAME|* has been successfully deleted.

      If you have any questions or need further clarification, please don’t hesitate to contact us at *|RENTAL:PHONE|*.

      We appreciate your attention to this update and look forward to ensuring your stay is seamless.
      `,
  },
}
